export const KEYS = {
    secretKey: "68a4gfh4f5fda4a8ghj7847ytjh4gs98q",
    user: "wq4d5c1dfr8rt4fg",
    iBan: "a8f9716ec0cb4714a9d8a50fd29629da"
}